import * as React from "react";
import { Box } from "@chakra-ui/react";

import { BADGE_COLORS } from "utils/css/consts";
import { ReactFCC } from "src/types/types";

export interface IBadge {
  type?: keyof typeof BADGE_COLORS;
}

const Badge: ReactFCC<IBadge> = ({ children, type = "neutral" }) => (
  <Box
    py="5px"
    px="15px"
    fontSize="14px"
    borderRadius="7px"
    border={`1px solid ${BADGE_COLORS[type].borderColor}`}
    color={BADGE_COLORS[type].fontColor}
    background={BADGE_COLORS[type].backgroundColor}
    display="flex"
    flexDirection="row"
    justifyContent="space-around"
    alignItems="center"
  >
    {children}
  </Box>
);

export default Badge;
